import React, { useEffect, useState } from 'react';
import { MenuIcon, MessageCircleIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { SITE_CONFIG, WHATSAPP_MESSAGES } from '../config/siteConfig';
import { createWhatsAppUrl, trackEvent } from '../utils/analytics';
const LOGO_COLOR = 'https://cdn.magicpatterns.com/uploads/fdWnQMUp9fhE8KAVDmQakg/AZ_Logo_final_Colores.png';
const navLinks = [{
  name: 'Ejemplos',
  href: '#ejemplos'
}, {
  name: 'Qué incluye',
  href: '#incluye'
}, {
  name: 'Cómo funciona',
  href: '#proceso'
}, {
  name: 'Precio',
  href: '#precio'
}, {
  name: 'Preguntas',
  href: '#preguntas'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isRestaurantRoute = window.location.pathname.replace(/\/+$/, '').endsWith('/restaurantes');
  const contactMessage = isRestaurantRoute ? WHATSAPP_MESSAGES.restaurant : WHATSAPP_MESSAGES.general;
  useEffect(() => {
    function handleScroll() {
      setIsScrolled(window.scrollY > 20);
    }
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  function closeMobileMenu() {
    setIsMobileMenuOpen(false);
  }
  function trackNavbarClick(location: string) {
    trackEvent(isRestaurantRoute ? 'whatsapp_restaurant_click' : 'whatsapp_hero_click', {
      cta_location: location,
      selected_product: SITE_CONFIG.product.name
    });
  }
  return <nav aria-label="Navegación principal" className={`fixed inset-x-0 top-0 z-50 max-w-full border-b transition-all duration-300 ${isScrolled ? 'border-white/10 bg-[#050511]/95 py-3 backdrop-blur-xl' : 'border-transparent bg-[#050511]/75 py-3.5 backdrop-blur-md'}`} data-id="element-1028">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-2 px-4 sm:gap-4 sm:px-6 lg:px-8" data-id="element-1029">
        <a href={isRestaurantRoute ? '/restaurantes' : '#'} className="flex min-w-0 shrink items-center" data-id="element-1030">
          <img src={LOGO_COLOR} alt="Estrategias Digitales A-Z" className="h-9 max-w-[128px] object-contain object-left sm:h-10 sm:max-w-[150px] md:h-11" data-id="element-1031" />
        </a>

        <div className="hidden min-w-0 items-center gap-5 xl:flex" data-id="element-1032">
          {navLinks.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-sm font-medium text-[#c8c8d4] transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[#20d6e8]" data-id="element-1033">
              {link.name}
            </a>)}
          <a href={createWhatsAppUrl(contactMessage)} target="_blank" rel="noopener noreferrer" onClick={() => trackNavbarClick('navbar')} className="inline-flex min-h-11 shrink-0 items-center rounded-xl bg-[#25d366] px-4 text-sm font-semibold text-[#06170c] transition-colors hover:bg-[#3ee47a] focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-1034">
            Cotizar por WhatsApp
          </a>
        </div>

        <div className="flex shrink-0 items-center gap-2 xl:hidden" data-id="element-1035">
          <a href={createWhatsAppUrl(contactMessage)} target="_blank" rel="noopener noreferrer" aria-label="Cotizar por WhatsApp" onClick={() => trackNavbarClick('navbar_mobile')} className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[#25d366] text-[#06170c] focus:outline-none focus-visible:ring-2 focus-visible:ring-white sm:w-auto sm:gap-2 sm:px-3" data-id="element-1036">
            <MessageCircleIcon className="h-4 w-4" data-id="element-1037" />
            <span className="hidden text-sm font-semibold sm:inline" data-id="element-1038">
              WhatsApp
            </span>
          </a>
          <button type="button" onClick={() => setIsMobileMenuOpen(current => !current)} aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isMobileMenuOpen} className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[#20d6e8]" data-id="element-1039">
            {isMobileMenuOpen ? <XIcon className="h-5 w-5" data-id="element-1040" /> : <MenuIcon className="h-5 w-5" data-id="element-1041" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-1042">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="overflow-hidden border-t border-white/10 bg-[#0c0c1c] xl:hidden" data-id="element-1043">
            <div className="space-y-1 px-4 py-4 sm:px-6" data-id="element-1044">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={closeMobileMenu} className="flex min-h-11 items-center rounded-lg px-3 text-base font-medium text-[#d8d8e3] hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#20d6e8]" data-id="element-1045">
                  {link.name}
                </a>)}
              <a href={createWhatsAppUrl(contactMessage)} target="_blank" rel="noopener noreferrer" onClick={() => {
            trackNavbarClick('mobile_menu');
            closeMobileMenu();
          }} className="mt-3 flex min-h-12 items-center justify-center rounded-xl bg-[#25d366] px-4 font-semibold text-[#06170c]" data-id="element-1046">
                {isRestaurantRoute ? 'Quiero mi menú digital' : 'Cotizar por WhatsApp'}
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}